import { mapGetters, mapActions } from 'vuex';

//---helpers
import { globalLoader, MEDIA } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import PromotionsCard from '@/components/cards/PromotionCard/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'promotions',
  mixins: [dynamicHead],
  components: { BreadcrumbsSimple, Pagination, PromotionsCard },
  data() {
    return {
      MEDIA,
      promotionsData: null,
      isPromotionsLoading: false,
      promotionsPage: 1,
      promotions: [],
      promotionsMeta: null
    };
  },

  async created() {
    globalLoader(true);
    await this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      promotionsProducts: 'sales/promotionsProducts'
    })
  },
  methods: {
    ...mapActions({
      getPromotionsProducts: 'sales/GET_PROMOTIONS_PRODUCTS',
      getPage: 'staticPages/GET_PAGE'
    }),

    async _getProducts() {
      this.isPromotionsLoading = true;
      let { page } = this.$route.query;

      let params = {
        page: page ? Number(page) : 1
      };

      return this.getPromotionsProducts(params)
        .then((result) => {
          this.promotions = page ? [...this.promotions, ...result.data] : result.data;
          this.promotionsMeta = result.meta;
        })
        .finally(() => {
          this.isPromotionsLoading = false;
        });
    },

    async _loadContent() {
      let promiseCollection = [];
      promiseCollection.push(this._getProducts());
      promiseCollection.push(
        this.getPage('promotions').then((data) => {
          this.promotionsData = data;
          this._setMetaParams();
        })
      );

      await Promise.all(promiseCollection).then();
      globalLoader(false);
    },

    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.promotionsData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
